import styled from "styled-components";

export const ContainerPage = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    
    .body{
        margin-bottom: 200px;
    }

    img{
        height: auto;
        width: 370px;
    }

    .div-topo{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;
    }

    h2{
        font-size: 20px;
        margin-top: 20px;
        margin-left: 10px;
    }

    bold{
        font-size: 22px;
        font-weight: 700;
    }

    .modulos{
        display: flex;
        flex-direction: flex;
        justify-content: center;
    }

    .modulo{
        width: 120px;
        height: 120px;
        border: solid 1px var(--principal);
        margin: 0px 20px;
        border-radius: 8px;
        cursor: pointer;

        svg{
            width: 60px;
            height: 60px;
        }

        path{
            fill: var(--principal);
        }
    }
    
    .icone{
        width: 60px;
        height: 60px;
        margin: 15px auto 3px;
    }

    h4{
        font-weight: 600;
        font-size: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .disable{
        background-color:rgb(218, 218, 218);
        cursor: auto;

        svg {
        path,
        polygon,
        rect,
        circle,
        ellipse {
          fill: #A3A3A3;
        }
      }
    }
`